import React, { useRef, useEffect } from 'react'
import lottie from 'lottie-web'
import { LottieAnimationProps } from './types'

/**
 * @func LottieAnimation
 * @param {LottieAnimationProps} props
 * @returns {JSX.Element}
 */
export const LottieAnimation = ({ file }: LottieAnimationProps): JSX.Element => {
  const container = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!container.current) return
    const animation = lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      autoplay: false,
      loop: true,
      path: file,
    })
    const mainLoop = () => {
      animation.playSegments([300, 900], true)
      animation.removeEventListener('loopComplete')
    }

    animation.playSegments([0, 300], true)
    animation.removeEventListener('loopComplete')
    animation.addEventListener('loopComplete', mainLoop)
  }, [file])

  return <div ref={container} style={{ height: '100%' }} />
}
